import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FcpButtonModule, FcpDropdownModule, FcpIconModule } from 'fc-ui-components';

import { ReferralSignupComponent } from './referral-signup.component';
import { NavigationBlockerLayoutModule } from '../../components/navigation-blocker-layout/navigation-blocker-layout.module';
import { ResponsiveWrapperModule } from '../../../components/responsive-wrapper/responsive-wrapper.module';
import { StartReferralSignupComponent } from './start-referral/start-referral/start-referral.component';

@NgModule({
    declarations: [ReferralSignupComponent, StartReferralSignupComponent],
    imports: [
        CommonModule,
        NavigationBlockerLayoutModule,
        TranslateModule,
        FcpDropdownModule,
        FcpIconModule,
        ResponsiveWrapperModule,
        FcpButtonModule,
        RouterModule,
        ReactiveFormsModule
    ]
})
export class ReferralSignupModule {}
